import { FilterAuswahlButton, FilterInput, FilterList, Filterpart } from "../StyleSheets/VvLinieProduktFilterStyle";

export function VvLinieProduktFilter({
    placeholder,
    show, setShow,
    textSearch, setTextSearch,
    chooseAll, setChooseAll,
    checkboxes, setCheckboxes,
    list, attribut,
    setReload }) {

    const selectAll = e => {
        e.preventDefault();
        setChooseAll(true);
        Object.keys(checkboxes).map(it => setCheckboxes(pre => ({ ...pre, [it]: true })));
    }

    const deselectAll = e => {
        e.preventDefault();
        setChooseAll(false);
        Object.keys(checkboxes).map(it => setCheckboxes(pre => ({ ...pre, [it]: false })));
    }
    const updateSelection = event => {
        setReload(true);
        setCheckboxes(pre => ({ ...pre, [event.target.value]: event.target.checked }));
    }

    return (
        <Filterpart onMouseLeave={() => setShow(false)} onMouseEnter={() => setShow(true)}>
            <FilterInput placeholder={placeholder} value={textSearch} onChange={e => setTextSearch(e.target.value)} />
            {show && <FilterList type="none">
                <li>{chooseAll ?
                    <FilterAuswahlButton onClick={deselectAll}>Alle abwählen</FilterAuswahlButton> :
                    <FilterAuswahlButton onClick={selectAll}>Alle auswählen</FilterAuswahlButton>
                }</li>
                {list
                    .filter(it => it[attribut].toString().toLowerCase().indexOf(textSearch.toLowerCase()) > -1)
                    .map(it =>
                        <li key={it.id}>
                            <label>
                                <input type="checkbox" checked={checkboxes[it.id]} value={it.id} onChange={updateSelection} />
                                {it[attribut]}
                            </label>
                        </li>
                    )}
            </FilterList>}
        </Filterpart>
    )
}